import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'fieldInput',
    'fieldTemplate',
    'section',
    'sectionTemplate',
    'selectedFields',
  ]

  connect() {
    this.fieldInputTargets.
      filter((input) => input.checked).
      forEach((input) => {
        this.#addFieldToSelectedFields({
          input: input,
          sort: false,
        })
      })

    this.#sortSections()
    this.sectionTargets.forEach((section) => this.#sortSection(section))
  }

  toggleFieldSelection(event) {
    const input = event.target

    if (input.checked) {
      this.#addFieldToSelectedFields({ input: input })
    } else {
      this.#removeFieldFromSelectedFields(input)
    }
  }

  #addFieldToSelectedFields({ input, sort = true }) {
    const section = this.#findOrCreateSection({
      sectionId: input.dataset.sectionId,
      sectionName: input.dataset.sectionName,
      sort: sort,
    })

    const field = this.#findOrCreateField({
      fieldId: input.dataset.fieldId,
      fieldName: input.dataset.fieldName,
      section: section,
      sort: sort,
    })
  }

  #findOrCreateField({ fieldId, fieldName, section, sort }) {
    const field = section.querySelector(`#${fieldId}`)
    if (field) return field

    window.Valence.Utils.Templates.cloneTemplate({
      callback: (clone) => {
        clone.children[0].id = fieldId
        clone.children[0].innerText = fieldName
      },
      container: section,
      template: this.fieldTemplateTarget,
    })

    if (sort) {
      this.#sortSection(section)
    }

    return section.querySelector(`#${fieldId}`)
  }

  #findOrCreateSection({ sectionId, sectionName, sort }) {
    const section =  this.selectedFieldsTarget.querySelector(`#${sectionId}`)
    if (section) return section

    window.Valence.Utils.Templates.cloneTemplate({
      callback: (clone) => {
        clone.children[0].id = sectionId
        clone.children[0].children[0].innerText = sectionName
      },
      container: this.selectedFieldsTarget,
      template: this.sectionTemplateTarget,
    })

    if (sort) {
      this.#sortSections()
    }

    return this.selectedFieldsTarget.querySelector(`#${sectionId}`)
  }

  #removeFieldFromSelectedFields(input) {
    const section = this.#findOrCreateSection({
      sectionId: input.dataset.sectionId,
      sectionName: input.dataset.sectionName,
      sort: false,
    })
    const field = section.querySelector(`#${input.dataset.fieldId}`)

    if (field) {
      field.remove()
    }

    if (section.children.length === 1) {
      section.remove()
    }
  }

  #sortSection(section) {
    Array.from(section.children).slice(1).sort((a, b) => {
      return a.innerText.localeCompare(b.innerText)
    }).forEach((field) => section.appendChild(field))
  }

  #sortSections() {
    Array.from(this.selectedFieldsTarget.children).sort((a, b) => {
      return a.children[0].innerText.localeCompare(b.children[0].innerText)
    }).forEach((section) => this.selectedFieldsTarget.appendChild(section))
  }
}
